import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoutes = ({ component: Component, ...rest }) => {
  const { uid, user } = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (uid && user) {
          if (user.type === "admin") {
            return <Redirect to="/super-admin" />;
          } else {
            return <Redirect to="/admin" />;
          }
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PublicRoutes;
